export default {
    DATA_LOADED: 'pc_data_loaded'
}


// WEBPACK FOOTER //
// ./App/components/modules/profile/action-types.js